import { Map } from "immutable";
import { createSelector } from "reselect";

import SessionModule from "../../../../../models/SessionModule";

type State = SessionModule;

export function getContentModuleId(state: State): string {
  return state.contentModuleId!;
}

export function getContentId(state: State) {
  return state.contentId!;
}

export function getWordId(state: State) {
  return state.wordId;
}

export function getSkill(state: State) {
  return state.skill;
}

export function getTextToSpeechDisabled(state: State) {
  return state.textToSpeechDisabled;
}

export function getModuleType(state: State) {
  return state.moduleType!;
}

export function getContent(state: State) {
  return state.content;
}

export const moduleContainsGIF = createSelector(getContentImage, image => {
  if (!image) return false;
  const regExp = /gif|mp4/i;
  const imageUrl = image.get("url");
  return imageUrl && regExp.test(imageUrl);
});

export function getContentImage(state: State) {
  const moduleType = getModuleType(state);
  const content = getContent(state);

  switch (moduleType) {
    case "concept": {
      const firstSlide = content.get("examples").first();
      return getImageFromContent(firstSlide);
    }

    default: {
      return getImageFromContent(content);
    }
  }
}

function getImageFromContent(state: Map<any, any>) {
  return state.get("image");
}

export function getTestingActive(state: State) {
  return state.testingActive;
}

export function getTimeStarted(state: State) {
  return state.timeStarted;
}

export function getTimeFinished(state: State) {
  return state.timeFinished;
}

export function getModuleState(state: State) {
  return state.moduleState;
}

export function getCompleted(state: State) {
  return state.completed;
}

export function getSubmitted(state: State) {
  return state.submitted;
}

export function getGaveUp(state: State) {
  return state.gaveUp;
}

export function getUserAnswer(state: State) {
  return state.userAnswer;
}

export function getScore(state: State) {
  return state.score || 0;
}

export function wasCorrect(state: State) {
  const { score } = state;
  return !isNaN(score!) && score! >= 1;
}

export function wasIncorrect(state: State) {
  const { score } = state;
  return !isNaN(score!) && score! < 1;
}

export const createScoreSelector = (
  answerLogic: (
    arg0: Record<string, any> | null | undefined,
    arg1: Record<string, any> | null | undefined
  ) => Record<string, any>
) =>
  createSelector(getContent, getUserAnswer, (content, answer) =>
    answerLogic(
      content ? content.toJS() : undefined,
      answer ? answer.toJS() : undefined
    )
  );

export function moduleStillInProgress(state: State): boolean {
  const testingActive = getTestingActive(state);
  const submitted = getSubmitted(state);
  const gaveUp = getGaveUp(state);
  const completed = getCompleted(state);

  return completed
    ? false
    : (testingActive && !submitted && !gaveUp) ||
        (!testingActive && !completed);
}
